var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Modal from '../../Components/ComponentModal';
import Input from '../../Components/ComponentInput';
import Button from '../../Components/ComponentButton';
import T from '../../Utils/Locale';
import { getGlobalState, setGlobalState } from '../../Utils/GlobalState';
const MissingPhoneNumberModal = ({ onAdd, onClose }) => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [error, setError] = useState('');
    return (_jsxs(Modal, Object.assign({ closeModal: onClose }, { children: [_jsx("h2", { children: T('basket.phone.title') }), _jsxs("form", Object.assign({ onSubmit: handleSubmit, className: 'flex items-end' }, { children: [_jsx(Input, { id: 'phone-number', name: 'phone', type: 'number', placeholder: T('basket.phone.placeholder'), value: phoneNumber, onChange: setPhoneNumber, wrapperClasses: 'flex-1', error: error }), _jsx(Button, Object.assign({ isSubmit: true, id: 'submit-phone-number', classes: 'button tailwind-reset btn cursor-pointer bg-dark-teal text-white shadow hover:bg-dark-teal cursor-pointer py-4 px-6 ml-2' }, { children: T('basket.phone.cta') }))] }))] })));
    function handleSubmit(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            if (phoneNumber.length === 0) {
                setError(T('basket.phone.error'));
                return;
            }
            if (error.length > 0) {
                setError('');
            }
            try {
                const { data } = yield axios.post('/api/users/phone', { phone: phoneNumber }, { withCredentials: true });
                if (data === 'Phone is not a valid number' || data === 'Phone not found in Request') {
                    setError(T('basket.phone.error'));
                    return;
                }
                const user = getGlobalState('user');
                setGlobalState('user', Object.assign(Object.assign({}, user), { phone: phoneNumber }));
                setTimeout(() => {
                    onClose();
                    onAdd();
                });
            }
            catch (error) {
                setError(T('basket.phone.genericError'));
            }
        });
    }
};
MissingPhoneNumberModal.prototype = {
    onPhoneNumberAdd: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
export default MissingPhoneNumberModal;
